module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0099.jpg?v=db095517";